import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="min-h-[80vh] flex items-center justify-center bg-background-50 pt-16">
        <div className="text-center px-4">
          <span className="w-20 h-20 mx-auto flex items-center justify-center mb-6">
            <i className="ri-emotion-sad-line text-foreground-300 text-5xl"></i>
          </span>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-3">404</h1>
          <p className="text-foreground-500 text-base md:text-lg mb-2">页面未找到</p>
          <p className="text-foreground-400 text-sm mb-8">您访问的页面不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-200"
          >
            <i className="ri-home-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}